import { MeterModel, SerializedMeterModel } from '@enmon/commons/lib/tools';
import { Authenticator, RequestConfig } from 'services/httpClient';
import { buildQuery } from '@enmon/commons/lib/tools/utils/buildQuery';
import { Commodity } from '@enmon/commons';
import { BaseApiClient } from './baseApiClient';
import { StrapiApiResponse } from '../../types/strapiResponse';

export interface MeterModelsFilter {
  commodity?: Commodity;
}

export class MeterModelsApiClient extends BaseApiClient<SerializedMeterModel> {
  constructor(authenticator: Authenticator | undefined) {
    super('meter-models', authenticator);
  }

  /**
   * Return all items from the meter models API with no limit
   */
  async getAll(options?: RequestConfig): Promise<SerializedMeterModel[]> {
    const response = await this.http.get<StrapiApiResponse<SerializedMeterModel>>('', {
      ...options,
      params: buildQuery<MeterModel>({
        filters: {},
        // NOTE: limit -1 will return all items from the API
        pagination: { start: 1, limit: -1 },
        // @ts-expect-error buildQuery does not support fields of populate
        populate: {
          manufacturer: { fields: ['id', 'name'] },
          meter_addons: { fields: ['id', 'name'] },
        },
        fields: ['id', 'name', 'commodity', 'details'],
      }),
    });

    return response.data;
  }

  async findOne(id: SerializedMeterModel['id'], options?: RequestConfig): Promise<SerializedMeterModel> {
    return await super.getOne(encodeURIComponent(id), undefined, options);
  }
}
